import {Box, BoxProps, Skeleton, Typography} from '@mui/material';

export interface LabeledComponentProps extends BoxProps {
  title?: string;
  value?: string | string[];
  invert?: boolean;
  loading: boolean | null;
  emptyState?: React.ReactNode;
}

const LabeledValue = ({
  title,
  invert,
  value,
  loading,
  emptyState,
  ...props
}: LabeledComponentProps) => {
  return (
    <Box my={1} {...props}>
      <Typography
        component={'p'}
        lineHeight={'21px'}
        color={invert ? 'text.primary' : 'text.secondary'}
        fontSize={{xxs: 14}}
        fontWeight={invert ? 500 : 400}
        variant="subtitle2"
      >
        {loading !== false ? <Skeleton width={120} /> : title ?? 'Industry'}
      </Typography>

      {Array.isArray(value) ? (
        loading !== false ? (
          <Skeleton width={150} />
        ) : Boolean(value?.length) ? (
          value.map((v, i) => (
            <Typography
              key={`labeled-component-${i}`}
              component={'p'}
              lineHeight={'21px'}
              fontSize={{xxs: 14}}
              variant="subtitle2"
              fontWeight={invert ? 400 : 500}
              color={!invert ? 'text.primary' : 'text.secondary'}
            >
              {v ?? 'Something should be here'}
            </Typography>
          ))
        ) : (
          emptyState
        )
      ) : (
        <Typography
          component={'p'}
          lineHeight={'16px'}
          fontSize={{xxs: 14}}
          variant="subtitle2"
          fontWeight={invert ? 400 : 500}
          color={!invert ? 'text.primary' : 'text.secondary'}
        >
          {loading !== false ? (
            <Skeleton width={150} />
          ) : value?.length ? (
            value
          ) : (
            emptyState ?? ''
          )}
        </Typography>
      )}
    </Box>
  );
};

export default LabeledValue;
